module.exports = __webpack_public_path__ + "static/media/Senate-1.49b520b0.pdf";